import { render, staticRenderFns } from "./loginCommon.vue?vue&type=template&id=5c3a90e6&scoped=true&"
import script from "./loginCommon.vue?vue&type=script&lang=js&"
export * from "./loginCommon.vue?vue&type=script&lang=js&"
import style0 from "./loginCommon.vue?vue&type=style&index=0&id=5c3a90e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a90e6",
  null
  
)

export default component.exports